module.exports = __webpack_public_path__ + "img/btnCard-8-m.a53d5338.jpg";